import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ContactPhoneIcon(props: IconProps) {
    return <Icon {...props} iconKey={"contact_phone"}/>
}
